export const reportTypes = {
  packingList: {
    id: 'packingList',
    name: 'Packing list',
    fileName: 'packing-list',
  },
  karex: { id: 'karex', name: 'karex', fileName: 'karex' },
  lz: { id: 'lz', name: 'L & Z' },
  rosan: { id: 'rosan', name: 'Rosan', fileName: 'rosan' },
  customs: { id: 'customs', name: 'Customs', fileName: 'customs' },
  israel: { id: 'israel', name: 'Israel', fileName: 'israel' },
};
